<template>
  <div id="Declaration_config_preview" class="xv_modal">
    <div class="multitab_preview">
      <b-tabs fill>
        <b-tab title="Employee Health declaration" active>
          <div class="hd_preview">
            <div class="header">
              <button class="modal_close" @click="close_declaration_config_preview()">
                <span class="mdi mdi-close"></span>
              </button>
            </div>
            <div class="sub_header">
              <span>Employee information</span>
            </div>
            <div class="hd_preview_content">
              <table class="hd_table">
                <thead>
                  <tr>
                    <th style="width:30%"></th>
                    <th style="width:70%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Name</td>
                    <td>Becky Ross</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>beckyross@gmail.com</td>
                  </tr>
                  <tr>
                    <td>Phone number</td>
                    <td>+1-202-555-0197</td>
                  </tr>
                  <tr>
                    <td>Id</td>
                    <td>#3456</td>
                  </tr>
                  <tr>
                    <td>Mask id</td>
                    <td>#4567654</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hd_preview_content declaration">
              <table class="hd_table">
                <thead>
                  <tr>
                    <th style="width:6%"></th>
                    <th style="width:64%">Declaration</th>
                    <th style="width:15%">Yes</th>
                    <th style="width:15%">No</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1.</td>
                    <td>
                      Are you having?
                      <div class="row sub_declaration">
                        <div class="col-4">
                          a) Fever
                          <input type="text" class="fever_temp" placeholder="Temperature" />
                        </div>
                        <div class="col-8">
                          <b-form-checkbox
                            v-model="sub_declaration[0]"
                            disabled
                            id="checkbox-1"
                            name="checkbox-1"
                            value="check"
                          ></b-form-checkbox>
                        </div>
                      </div>
                      <div class="row sub_declaration">
                        <div class="col-4">b) Cough</div>
                        <div class="col-8">
                          <b-form-checkbox
                            v-model="sub_declaration[1]"
                            disabled
                            id="checkbox-2"
                            name="checkbox-2"
                            value="check"
                          ></b-form-checkbox>
                        </div>
                      </div>
                      <div class="row sub_declaration">
                        <div class="col-4">c) Sore throat</div>
                        <div class="col-8">
                          <b-form-checkbox
                            disabled
                            v-model="sub_declaration[2]"
                            id="checkbox-3"
                            name="checkbox-3"
                            value="check"
                          ></b-form-checkbox>
                        </div>
                      </div>
                    </td>
                    <td>
                      <b-form-radio name="1" value="A" v-model="declaration_1[0]" disabled></b-form-radio>
                    </td>
                    <td>
                      <b-form-radio name="1" value="B" v-model="declaration_1[0]" disabled></b-form-radio>
                    </td>
                  </tr>
                  <tr>
                    <td>2.</td>
                    <td>
                      Is any family member diagnosed with the virus or under
                      quarantine?
                    </td>
                    <td>
                      <b-form-radio name="2" value="A" v-model="declaration_1[1]" disabled></b-form-radio>
                    </td>
                    <td>
                      <b-form-radio name="2" value="B" v-model="declaration_1[1]" disabled></b-form-radio>
                    </td>
                  </tr>
                  <tr>
                    <td>3.</td>
                    <td>
                      Have you been served a government quarantine order or
                      under self quanratine
                    </td>
                    <td>
                      <b-form-radio name="3" value="A" v-model="declaration_1[2]" disabled></b-form-radio>
                    </td>
                    <td>
                      <b-form-radio name="3" value="B" v-model="declaration_1[2]" disabled></b-form-radio>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hd_preview_content legal">
              <div class="row">
                <div class="col-12">
                  <span>
                    I consent to the collection of my personal data and its use
                    and its agents for the purpose of contact tracing.The
                    company is entitled to retain the information for audit
                    purpose. I certify that the above responses are true,
                    accurate and complete.
                  </span>
                </div>
              </div>
            </div>

            <div class="hd_preview_content footer">
              <div class="row">
                <div class="col-6 text-center">
                  <span>Signature</span>
                </div>
                <div class="col-6 text-center">
                  <span>Date</span>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Visitor Health declaration">
          <div class="hd_preview">
            <div class="header">
              <button class="modal_close" @click="close_declaration_config_preview()">
                <span class="mdi mdi-close"></span>
              </button>
            </div>

            <div class="sub_header">
              <span>Visitor information</span>
            </div>
            <div class="hd_preview_content">
              <table class="hd_table">
                <thead>
                  <tr>
                    <th style="width:30%"></th>
                    <th style="width:70%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Visitor Name</td>
                    <td>Phillippa Bass</td>
                  </tr>
                  <tr>
                    <td>Person to Meet</td>
                    <td>Joseph Davis</td>
                  </tr>
                  <tr>
                    <td>Comapany</td>
                    <td>Microsoft</td>
                  </tr>
                  <tr>
                    <td>Floor</td>
                    <td>8</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hd_preview_content declaration">
              <table class="hd_table">
                <thead>
                  <tr>
                    <th style="width:6%"></th>
                    <th style="width:64%">Declaration</th>
                    <th style="width:15%">Yes</th>
                    <th style="width:15%">No</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1.</td>
                    <td>
                      Are you having?
                      <div class="row sub_declaration">
                        <div class="col-4">
                          a) Fever
                          <input type="text" class="fever_temp" placeholder="Temperature" />
                        </div>
                        <div class="col-8">
                          <b-form-checkbox
                            v-model="sub_declaration[0]"
                            disabled
                            id="checkbox-1"
                            name="checkbox-1"
                            value="check"
                          ></b-form-checkbox>
                        </div>
                      </div>
                      <div class="row sub_declaration">
                        <div class="col-4">b) Cough</div>
                        <div class="col-8">
                          <b-form-checkbox
                            v-model="sub_declaration[1]"
                            disabled
                            id="checkbox-2"
                            name="checkbox-2"
                            value="check"
                          ></b-form-checkbox>
                        </div>
                      </div>
                      <div class="row sub_declaration">
                        <div class="col-4">c) Sore throat</div>
                        <div class="col-8">
                          <b-form-checkbox
                            disabled
                            v-model="sub_declaration[2]"
                            id="checkbox-3"
                            name="checkbox-3"
                            value="check"
                          ></b-form-checkbox>
                        </div>
                      </div>
                    </td>
                    <td>
                      <b-form-radio name="4" value="A" v-model="declaration_2[0]" disabled></b-form-radio>
                    </td>
                    <td>
                      <b-form-radio name="4" value="B" v-model="declaration_2[0]" disabled></b-form-radio>
                    </td>
                  </tr>
                  <tr>
                    <td>2.</td>
                    <td>
                      Is any family member diagnosed with the virus or under
                      quarantine?
                    </td>
                    <td>
                      <b-form-radio name="5" value="A" v-model="declaration_2[1]" disabled></b-form-radio>
                    </td>
                    <td>
                      <b-form-radio name="5" value="B" v-model="declaration_2[1]" disabled></b-form-radio>
                    </td>
                  </tr>
                  <tr>
                    <td>3.</td>
                    <td>
                      Have you been served a government quarantine order or
                      under self quanratine
                    </td>
                    <td>
                      <b-form-radio name="6" value="A" v-model="declaration_2[2]" disabled></b-form-radio>
                    </td>
                    <td>
                      <b-form-radio name="6" value="B" v-model="declaration_2[2]" disabled></b-form-radio>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hd_preview_content legal">
              <div class="row">
                <div class="col-12">
                  <span>
                    I consent to the collection of my personal data and its use
                    and its agents for the purpose of contact tracing.The
                    company is entitled to retain the information for audit
                    purpose. I certify that the above responses are true,
                    accurate and complete.
                  </span>
                </div>
              </div>
            </div>

            <div class="hd_preview_content footer">
              <div class="row">
                <div class="col-6 text-center">
                  <span>Signature</span>
                </div>
                <div class="col-6 text-center">
                  <span>Date</span>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
// import employeePolicies from "./employee_policies/employee_policies.vue"

export default {
  name: "Declaration_config_preview",
  components: {
    // employeePolicies,visitorPolicies,healthDeclarations,securityPartners,company,account
  },
  data() {
    return {
      declaration_1: ["A", "A", "B"],
      declaration_2: ["A", "A", "B"],
      sub_declaration: ["check", "", "check"]
    };
  },
  methods: {
    close_declaration_config_preview: function() {
      this.$modal.hide("declaration_config_preview");
    }
  }
};
</script>
